import { HSMSSelectOption } from '@components/shared';
import { intakes_for_selectQuery } from '@app-types/graphql-types';

export const getIntakesForSelect = (intakes?: intakes_for_selectQuery['intake']): HSMSSelectOption[] => {
  if (intakes) {
    return intakes.map((intake) => {
      return {
        value: intake.id,
        label: intake.name,
      };
    });
  }

  return [];
};
